import {
  Control,
  FieldValues,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';

import { WorkLocationOtherField } from '@app/components/Catalog/WorkLocationOtherField';
import { WorkplaceNameField } from '@app/components/Catalog/WorkplaceNameField';
import { Organization } from '@app/types/organization';
import { isManualWorkplaceInput } from '@app/utils/productOrganization';

interface ProductWorkplaceFieldProps<T extends FieldValues> {
  control: Control<T>;
  fullWidth?: boolean;
  organization: Organization;
  setValue: UseFormSetValue<T>;
  watch: UseFormWatch<T>;
}

/** 組織区分に応じて求人の勤務先入力を切り替える */
export function ProductWorkplaceField<T extends FieldValues>({
  control,
  fullWidth,
  organization,
  setValue,
  watch,
}: ProductWorkplaceFieldProps<T>) {
  if (isManualWorkplaceInput(organization)) {
    return <WorkplaceNameField control={control} />;
  }
  return (
    <WorkLocationOtherField
      control={control}
      organization={organization}
      setValue={setValue}
      watch={watch}
      fullWidth={fullWidth}
    />
  );
}
